import React from "react";

const InputSwitch = ({ label, value, setValue, disabled = false }) => {
	const handleChange = (e) => {
		setValue(e.target.checked);
	};

	return (
		<div className="mb-3">
			<div className="form-check form-switch">
				<input
					className="form-check-input"
					type="checkbox"
					id={`switch-${label}`}
					checked={value || false}
					onChange={handleChange}
					disabled={disabled}
				/>
				<label className="form-check-label" htmlFor={`switch-${label}`}>
					{label}
				</label>
			</div>
		</div>
	);
};

export default InputSwitch;
